import { render, staticRenderFns } from "./EditLodging.vue?vue&type=template&id=2ca7af9a"
import script from "./EditLodging.vue?vue&type=script&lang=js"
export * from "./EditLodging.vue?vue&type=script&lang=js"
import style0 from "./EditLodging.vue?vue&type=style&index=0&id=2ca7af9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports